// extracted by mini-css-extract-plugin
export default {"labelContainer":"AuthHeader_labelContainer__Qn-+a"};